import { render } from "./StockLedgerTable.vue?vue&type=template&id=89b8e676&scoped=true"
import script from "./StockLedgerTable.vue?vue&type=script&lang=js"
export * from "./StockLedgerTable.vue?vue&type=script&lang=js"

import "./StockLedgerTable.vue?vue&type=style&index=0&id=89b8e676&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b8e676"]])

export default __exports__